import React from "react"
import { graphql, useStaticQuery } from "gatsby"

export default function useDocumentCountry() {
  const result = useStaticQuery(
    graphql`
      {
        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            node_locale
            codigoIcu
            departamentos {
              codigo
              nombre
            }
            ciudades {
              codigo
              codigoDepartamento
              nombre
            }
          }
        }
      }
    `
  )

  const countries = [
    {
      name: "COLOMBIA",
      value: "es-CO",
      locale: "es-CO",
      prefix: "+57",
      code: 1,
      cellDig: 10,
    },
    {
      name: "ARGENTINA",
      value: "es-AR",
      locale: "es-AR",
      prefix: "+54",
      code: 9,
      cellDig: 10,
    },
    {
      name: "BOLIVIA",
      value: "es-BO",
      locale: "es-BO",
      prefix: "+591",
      code: 7,
      cellDig: 8,
    },
    {
      name: "CHILE",
      value: "es-CL",
      locale: "es-CL",
      prefix: "+56",
      code: 8,
      cellDig: 8,
    },
    {
      name: "REPÚBLICA DOMINICANA",
      value: "es-DO",
      locale: "es-DO",
      prefix: "+1",
      code: 13,
      cellDig: 10,
    },
    {
      name: "ECUADOR",
      value: "es-EC",
      locale: "es-EC",
      prefix: "+593",
      code: 5,
      cellDig: 10,
    },
    {
      name: "PERÚ",
      value: "es-PE",
      locale: "es-PE",
      prefix: "+51",
      code: 6,
      cellDig: 9,
    },
    {
      name: "PUERTO RICO",
      value: "es-PR",
      locale: "es-PR",
      prefix: "+1",
      code: 12,
      cellDig: 10,
    },
    {
      name: "PARAGUAY",
      value: "es-PY",
      locale: "es-PY",
      prefix: "+595",
      code: 11,
      cellDig: 10,
    },
    {
      name: "URUGUAY",
      value: "es-PY",
      locale: "es-PY",
      prefix: "+598",
      code: 10,
      cellDig: 10,
    },
  ]

  const removePrefix = cellPhone => {
    let cellPhoneNoPrefix = cellPhone
    countries.forEach(country => {
      if (cellPhone.includes(country.prefix)) {
        cellPhoneNoPrefix = cellPhone.replace(country.prefix, "")
      }
    })
    return cellPhoneNoPrefix
  }

  const actualLocale = process.env.LOCALE || "es-CO"
  const resultQuery = result?.allContentfulNolPaises?.nodes

  const getCountryInfo = locale => {
    let resultCmsInfo = resultQuery?.filter(content =>
      locale.includes(content.codigoIcu)
    )[0]

    let resultEnvInfo = countries.filter(c => c.locale === locale)[0]

    return { ...resultCmsInfo, ...resultEnvInfo }
  }

  const currentCountryInfo = getCountryInfo(actualLocale)

  const mapCitiesOptions = cities =>
    cities.map(option => ({
      value: option.codigo || option.value,
      name: option.nombre || option.name,
    })) || []

  const mapDeparmentOptions = deparments =>
    deparments?.map(option => ({
      value: option.codigo || option.value,
      name: option.nombre || option.name,
    })) || []

  const filterCitiesByDeparment = (
    deparment_id,
    locale = actualLocale,
    mapToOptions = true
  ) => {
    let options = getCountryInfo(locale).ciudades
    if (deparment_id) {
      options = options?.filter(
        city =>
          city.codigoDepartamento?.toString() === deparment_id?.toString() ||
          city.value?.toString() === deparment_id?.toString()
      )
    }
    if (mapToOptions) {
      return mapCitiesOptions(options)
    }
    return options
  }

  return {
    currentCountryInfo,
    actualCitiesList: currentCountryInfo.ciudades,
    actualDeparmentList: currentCountryInfo.departamentos,
    removePrefix,
    getCountryInfo,
    filterCitiesByDeparment,
    mapCitiesOptions,
    mapDeparmentOptions,
  }
}
